import React from 'react';
import { CheckmarkIcon, BookIcon, ShieldIcon, GroupIcon, LightbulbIcon } from './icons/CustomIcons';
export function Features() {
  const features = [{
    title: 'The true origins of a movement reshaping the conservative future',
    icon: <BookIcon className="w-6 h-6 text-red-700" data-id="element-50" />
  }, {
    title: 'How courage and faith built an unstoppable force against the tide',
    icon: <ShieldIcon className="w-6 h-6 text-red-700" data-id="element-51" />
  }, {
    title: 'The battles fought—and won—on college campuses and beyond',
    icon: <GroupIcon className="w-6 h-6 text-red-700" data-id="element-52" />
  }, {
    title: "What the media won't tell you about the real cost of speaking truth",
    icon: <LightbulbIcon className="w-6 h-6 text-red-700" data-id="element-53" />
  }, {
    title: 'The blueprint for defending liberty in your family, your church, and your community',
    icon: <CheckmarkIcon className="w-6 h-6 text-red-700" data-id="element-54" />
  }];
  return <div className="w-full py-16 px-4 md:px-8 lg:px-16 bg-gray-50" data-id="element-55">
      <div className="max-w-5xl mx-auto" data-id="element-56">
        <div className="flex items-center justify-center mb-12" data-id="element-57">
          <div className="h-0.5 w-12 bg-red-700" data-id="element-58"></div>
          <h2 className="text-3xl font-bold text-center mx-4 text-[#0c2340]" data-id="element-59">
            Inside The Book
          </h2>
          <div className="h-0.5 w-12 bg-red-700" data-id="element-60"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-61">
          <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-62">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ejHY4sU77jUDqcVEd9uVYg/ChatGPT_Image_Sep_26%2C_2025%2C_05_58_57_PM.png" alt="Charlie Kirk speaking" className="w-full h-auto rounded-md mb-6" data-id="element-63" />
            <p className="text-lg leading-relaxed" data-id="element-64">
              If you've spent your life standing for American values, this book
              is your reassurance—your voice is not fading. It is rising,
              stronger than ever, in a new generation that refuses to back down.
            </p>
            <p className="text-lg font-bold mt-4" data-id="element-65">
              Every page of Unshakable Conviction affirms what you already know
              deep inside: Freedom is fragile. Faith is under fire. But courage
              is contagious.
            </p>
          </div>
          <div data-id="element-66">
            <div className="bg-[#0c2340] text-white p-6 rounded-lg mb-8" data-id="element-67">
              <h3 className="text-xl font-bold mb-4 text-[#e9d28f]" data-id="element-68">
                Inside, you'll discover:
              </h3>
              <ul className="space-y-4" data-id="element-69">
                {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-70">
                    <div className="mt-1 mr-3 flex-shrink-0" data-id="element-71">
                      {feature.icon}
                    </div>
                    <p data-id="element-72">{feature.title}</p>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg border-l-4 border-red-700" data-id="element-73">
              <p className="text-lg italic mb-4" data-id="element-74">"Imagine this…"</p>
              <p className="text-lg mb-4" data-id="element-75">
                You pass this book to your son, your daughter, even your
                grandchild.
              </p>
              <p className="text-lg mb-4" data-id="element-76">
                They don't just read it. They feel it. They see themselves in
                the fight. And they understand, maybe for the first time, that
                they too must stand unshaken.
              </p>
              <p className="text-lg font-bold" data-id="element-77">
                This isn't just a book—it's a Weapon of Truth.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-white p-6 rounded-lg shadow-md" data-id="element-78">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qs4iJKxkchTYqpKA2e3epz/Generated_Image_September_28%2C_2025_-_11_26PM.png" alt="Book signing event" className="w-full h-auto rounded-md mb-6" data-id="element-79" />
          <p className="text-center text-lg font-bold" data-id="element-80">
            Packed with stories, strategies, and revelations, Unshakable
            Conviction isn't something to sit on a shelf. It's meant to be
            carried, shared, and lived. It's a rallying cry for those who refuse
            to let America's story end in silence.
          </p>
        </div>
      </div>
    </div>;
}